export enum ReportPeriodFilterEnum {
  ORDER_CREATE_DATE = 'ORDER_CREATE_DATE',
  ORDER_COLLECTION = 'ORDER_COLLECTION',
  PRODUCT_COLLECTION = 'PRODUCT_COLLECTION',
}
